module.exports = __webpack_public_path__ + "img/91634.30bb2921.svg";